import { apiClient } from "./client";

/**
 * Location API Service
 * Handles all location-related API calls
 */
const locationApi = {
  /**
   * Get all locations (filtered by user's tenant unless GlobalAdmin)
   */
  getAll: async (params = {}) => {
    return await apiClient.get("/locations", params);
  },

  /**
   * Get locations for dropdown selection
   */
  getDropdown: async (tenantId = null) => {
    const params = tenantId ? { tenantId } : {};
    return await apiClient.get("/locations/dropdown", params);
  },

  /**
   * Get a single location by ID
   */
  getById: async (id) => {
    return await apiClient.get(`/locations/${id}`);
  },

  /**
   * Create a new location
   * tenantId is sent as a query parameter (backend expects [FromQuery])
   */
  create: async (data, tenantId = null) => {
    const endpoint = tenantId
      ? `/locations?tenantId=${tenantId}`
      : "/locations";
    return await apiClient.post(endpoint, data);
  },

  /**
   * Update a location
   */
  update: async (id, data) => {
    return await apiClient.put(`/locations/${id}`, data);
  },

  /**
   * Delete a location
   */
  delete: async (id) => {
    return await apiClient.delete(`/locations/${id}`);
  },

  /**
   * Deactivate a location (soft delete)
   */
  deactivate: async (id) => {
    return await apiClient.post(`/locations/${id}/deactivate`);
  },

  /**
   * Get users with access to a location
   */
  getLocationUsers: async (locationId) => {
    return await apiClient.get(`/locations/${locationId}/users`);
  },

  /**
   * Grant user access to a location
   */
  grantAccess: async (data) => {
    return await apiClient.post("/locations/access", data);
  },

  /**
   * Update user's location access
   */
  updateAccess: async (accessId, data) => {
    return await apiClient.put(`/locations/access/${accessId}`, data);
  },

  /**
   * Revoke user's location access
   */
  revokeAccess: async (accessId) => {
    return await apiClient.delete(`/locations/access/${accessId}`);
  },
};

export default locationApi;
export { locationApi };
